import {$http} from '@/utils/https'
import {
    SETTING_GET_BASIC_COUNTRIES_LOADING,
    SETTING_GET_FORMATS_DATE_LOADING,
    SETTING_GET_LANGUAGE_INTERFACE_LOADING,
    SETTING_SET_BASIC_COUNTRIES,
    SETTING_SET_FORMATS_DATE,
    SETTING_SET_LANGUAGE_INTERFACE,
    SETTING_UPDATE_LOADING,
} from './types/mutation-types';

import {
    SETTING_GET_BASIC_COUNTRIES,
    SETTING_GET_FORMATS_DATE,
    SETTING_GET_LANGUAGE_INTERFACE,
    SETTING_UPDATE
} from './types/action-types';

const state = {
    languageInterface: [],
    languageInterfaceLoading: false,
    basicCountries: [],
    basicCountriesLoading: false,
    formatsDate: [],
    formatsDateLoading: false,
    updateSettingLoading: false,
};

const getters = {
    basicCountries: state => state.basicCountries,
    basicCountriesLoading: state => state.basicCountriesLoading,
    languageInterface: state => state.languageInterface,
    languageInterfaceLoading: state => state.languageInterfaceLoading,
    formatsDate: state => state.formatsDate,
    formatsDateLoading: state => state.formatsDateLoading,
    updateSettingLoading: state => state.updateSettingLoading,
};

const actions = {
    [SETTING_GET_LANGUAGE_INTERFACE]: async ({commit}, payload) => {
        try {
            commit(SETTING_GET_LANGUAGE_INTERFACE_LOADING, true);

            // const response = await $http.get(`${process.env.VUE_APP_ROOT_FAKE}`);
            // commit(SETTING_SET_LANGUAGE_INTERFACE, response.data.data)
            commit(SETTING_SET_LANGUAGE_INTERFACE, [
                {
                    value: 'uk',
                    name: 'Українська'
                },
                {
                    value: 'ru',
                    name: 'Русский'
                },
                {
                    value: 'en',
                    name: 'English'
                },
                {
                    value: 'id',
                    name: 'Indonesian'
                }
            ])
        } catch (e) {
            throw e;
        } finally {
            commit(SETTING_GET_LANGUAGE_INTERFACE_LOADING, false);
        }
    },
    [SETTING_GET_BASIC_COUNTRIES]: async ({commit}, payload) => {
        try {
            commit(SETTING_GET_BASIC_COUNTRIES_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COUNTRY}countries/basic?include=timezones,locales`);
            commit(SETTING_SET_BASIC_COUNTRIES, response.data.data)
        } catch (e) {
            throw e;
        } finally {
            commit(SETTING_GET_BASIC_COUNTRIES_LOADING, false);
        }
    },
    [SETTING_GET_FORMATS_DATE]: async ({commit}, payload) => {
        try {
            commit(SETTING_GET_FORMATS_DATE_LOADING, true);

            // const response = await $http.get(`${process.env.VUE_APP_ROOT_FAKE}`);
            // commit(SETTING_SET_FORMATS_DATE, response.data.data)
            commit(SETTING_SET_FORMATS_DATE, [
                {
                    id: 1,
                    name: 'дд / мм / гггг – 24 часа'
                },
                {
                    id: 2,
                    name: 'дд . мм . гггг – 24 часа'
                },
                {
                    id: 3,
                    name: 'дд - мм - гггг – 24 часа'
                }
            ])
        } catch (e) {
            throw e;
        } finally {
            commit(SETTING_GET_FORMATS_DATE_LOADING, false);
        }
    },
    [SETTING_UPDATE]: async ({commit}, payload) => {
        try {
            commit(SETTING_UPDATE_LOADING, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_USER}profile/setting`, payload);

            commit(`user/USER_UPDATE_DATA`, response.data.data, {root: true})
        } catch (e) {
            throw e;
        } finally {
            commit(SETTING_UPDATE_LOADING, false);
        }
    }
};

const mutations = {
    [SETTING_GET_LANGUAGE_INTERFACE_LOADING](state, status) {
        state.languageInterfaceLoading = status;
    },
    [SETTING_SET_LANGUAGE_INTERFACE](state, list) {
        state.languageInterface = list;
    },
    [SETTING_SET_BASIC_COUNTRIES](state, list) {
        state.basicCountries = list;
    },
    [SETTING_GET_BASIC_COUNTRIES_LOADING](state, status) {
        state.basicCountriesLoading = status;
    },
    [SETTING_GET_FORMATS_DATE_LOADING](state, status) {
        state.formatsDateLoading = status;
    },
    [SETTING_SET_FORMATS_DATE](state, list) {
        state.formatsDate = list;
    },
    [SETTING_UPDATE_LOADING](state, status) {
        state.updateSettingLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
